import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { DayIndex } from 'components/mrp/components/AppointmentForm/components/RecurrencePatternBuilder/RecurrencePatternBuilder.types';
import { createAppointmentFormDataFromEventResponse } from 'components/mrp/components/Calendar/components/CalendarAppointment/CalenderAppointment.utils';
import dayjs from 'dayjs';
import { GetFormDataProps } from './utils.types';

export const getFormData = ({
  baseEvent,
  isCut,
  newStart,
  sourceEntities,
  targetEntities,
  entitiesToReplace
}: GetFormDataProps): AppointmentFormFieldData => {
  const formData = createAppointmentFormDataFromEventResponse({
    ...baseEvent,
    // By using the original ID for the cuttingAction, we can mutate the
    // original event instead of creating a new one. This ensures we dont need
    // a separate delete step for the original event.
    ...(isCut ? { id: baseEvent.id } : { id: undefined })
  })!;

  formData.editAppointmentType = null;

  const timeDiff = newStart.diff(formData.start);
  formData.start = dayjs(formData.start).add(timeDiff).toISOString();
  formData.end = dayjs(formData.end).add(timeDiff).toISOString();

  if (formData.isRecurring && formData.recurrencePattern) {
    const selectedDate = dayjs(formData.start);
    formData.recurrencePattern.daysSelected = [
      (selectedDate.isoWeekday() - 1) as DayIndex
    ];

    if (formData.recurrencePattern.recurrenceEnd) {
      formData.recurrencePattern.recurrenceEnd = dayjs(
        formData.recurrencePattern.recurrenceEnd
      )
        .add(timeDiff)
        .toISOString();
    }
  }

  const allTargetsInSource = targetEntities.every((target) =>
    sourceEntities.some(
      (source) =>
        source.entityId === target.entityId &&
        source.planningEntityType === target.planningEntityType
    )
  );

  // Cutting and pasting from entity A to entity B while entity B is already
  // a part of the original event should not replace the entities and only
  // move the event.
  if (!allTargetsInSource) {
    const replacedEntityIds = entitiesToReplace.map(({ entityId }) => entityId);

    const newClients = targetEntities.filter(
      ({ planningEntityType }) => planningEntityType == 'CLIENT'
    );
    const newEmployees = targetEntities.filter(
      ({ planningEntityType }) => planningEntityType == 'EMPLOYEE'
    );
    const newResources = targetEntities.filter(
      ({ planningEntityType }) => planningEntityType == 'RESOURCE'
    );
    const newWorkplace = targetEntities.filter(
      ({ planningEntityType }) => planningEntityType == 'WORKPLACE'
    );

    formData.planEntities.CLIENT = [
      ...formData.planEntities.CLIENT.filter(
        ({ entityId }) => replacedEntityIds.indexOf(entityId) == -1
      ),
      ...newClients.map((pei) => ({ label: '', ...pei }))
    ];

    formData.planEntities.EMPLOYEE = [
      ...formData.planEntities.EMPLOYEE.filter(
        ({ entityId }) => replacedEntityIds.indexOf(entityId) == -1
      ),
      ...newEmployees.map((pei) => ({ label: '', ...pei }))
    ];

    formData.planEntities.RESOURCE = [
      ...formData.planEntities.RESOURCE.filter(
        ({ entityId }) => replacedEntityIds.indexOf(entityId) == -1
      ),
      ...newResources.map((pei) => ({ label: '', ...pei }))
    ];

    formData.planEntities.WORKPLACE = [
      ...formData.planEntities.WORKPLACE.filter(
        ({ entityId }) => replacedEntityIds.indexOf(entityId) == -1
      ),
      ...newWorkplace.map((pei) => ({ label: '', ...pei }))
    ];
  }

  return formData;
};
